import { useClientId, useCopyPasteStyles, useDeviceType } from "@blocks/hooks";
import { withSelect } from "@wordpress/data";
import { Fragment } from "@wordpress/element";
import { useBlockProps } from "@wordpress/block-editor";
import { __ } from "@wordpress/i18n";
import classnames from "classnames";
import React from "react";
import { EditProps } from "blocks/types";
import PlaceholderImage from "../../../images/placeholder.png";
import { useBlockStyle } from "../../hooks";
import "../assets/sass/blocks/post-image/style.scss";
import InspectorControls from "./components/InspectorControls";

interface Props extends EditProps<any> {
	featuredImage?: any;
}

const Edit: React.FC<Props> = (props) => {
	const {
		className,
		attributes: { hideOnDesktop },
		setAttributes,
		featuredImage,
	} = props;

	const { clientId } = useClientId(props);
	const { deviceType } = useDeviceType();
	const { CopyPasterStyleBlockControl } = useCopyPasteStyles();

	const { Style } = useBlockStyle({
		blockName: "post-image",
		clientId,
		attributes: props.attributes,
		deviceType,
	});

	const blockProps = useBlockProps({
		className: classnames(
			`mzb-post-image mzb-post-image-${clientId}`,
			className,
			hideOnDesktop && "magazine-blocks-hide-on-desktop"
		),
	});

	let imageSrc = PlaceholderImage;
	let altText = __("Featured image", "magazine-blocks");

	if (featuredImage && featuredImage.media_details) {
		const sizes = featuredImage.media_details.sizes || {};

		imageSrc =
			sizes["large"]?.source_url ||
			featuredImage.source_url ||
			PlaceholderImage;
		altText = featuredImage.alt_text || altText;
	}

	return (
		<Fragment>
			<InspectorControls
				attributes={props.attributes}
				setAttributes={setAttributes}
			/>
			<CopyPasterStyleBlockControl withBlockControls />
			<Style />
			<div {...blockProps}>
				<img src={imageSrc} alt={altText} />
			</div>
		</Fragment>
	);
};

// @ts-ignore
export default withSelect((select) => {
	const { getCurrentPost } = select("core/editor");
	const { getMedia } = select("core");

	const post = getCurrentPost();
	const featuredImageId = post?.featured_media;
	const featuredImage = featuredImageId ? getMedia(featuredImageId) : null;

	return {
		featuredImage,
	};
})(Edit);
